export function useDashboard() {
  const getAllBusinessesCAcompleted = async () => {
    const res = await $fetch(`/api/v1/dashboard/business-with-ca-completed`, {
      method: 'GET',
    })
    return res
  }

  const getBusinessTimeline = async (options: { skip?: number; take?: number }) => {
    const params = new URLSearchParams()
    if (options.skip !== undefined) {
      params.append('skip', options.skip.toString())
    }
    if (options.take !== undefined) {
      params.append('take', options.take.toString())
    }

    const res = await $fetch(
      `/api/v1/dashboard/business-timeline?${params.toString()}`,
      {
        method: 'GET',
      },
    )
    return res
  }

  const getIndustryAnalytics = async () => {
    const res = await $fetch('/api/v1/dashboard/industry-analytics', {
      method: 'GET',
    })
    return res
  }

  const getBusinessAnalytics = async () => {
    const res = await $fetch('/api/v1/dashboard/business-analytics', {
      method: 'GET',
    })
    return res
  }

  const getCommissionAnalytics = async () => {
    const res = await $fetch('/api/v1/dashboard/commission-analytics', {
      method: 'GET',
    })
    return res
  }

  const getVdrRequestsSummary = async () => {
    const res = await $fetch('/api/v1/dashboard/vdr-requests-summary', {
      method: 'GET',
    })
    return res
  }

  return {
    getAllBusinessesCAcompleted,
    getBusinessTimeline,
    getIndustryAnalytics,
    getBusinessAnalytics,
    getCommissionAnalytics,
    getVdrRequestsSummary,
  }
}
